import { useLayoutEffect, useState } from 'react';

export function useWindowSize() {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth > 1200) {
        setSize([window.innerWidth, window.innerHeight - 260]);
      } else {
        setSize([window.innerWidth, window.innerHeight - 200]);
      }
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}
